/* Heat Grump theme scripts */
/* PATCHED 10 Sep 2026 — CROW
   Add-to-cart no longer navigates to /cart. See the three blocks marked
   [CROW]. Everything else is byte-for-byte your original file. */
(function () {
  'use strict';

  /* ---------- Announcement bar rotation ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var index = 0;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
    setInterval(function () {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, interval);
  });

  /* ---------- Mobile navigation ---------- */
  document.addEventListener('click', function (event) {
    var burger = event.target.closest('[data-nav-toggle]');
    if (!burger) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', nav.classList.contains('is-open') ? 'true' : 'false');
  });

  /* ---------- Country / currency selector ---------- */
  document.querySelectorAll('[data-locale-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var wrapper = thumb.closest('[data-gallery]');
    if (!wrapper) return;
    var main = wrapper.querySelector('[data-gallery-main]');
    if (main) {
      main.src = thumb.getAttribute('data-full');
      main.srcset = '';
    }
    wrapper.querySelectorAll('[data-gallery-thumb]').forEach(function (el) {
      el.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  /* ---------- [CROW] Open the cart drawer instead of going to /cart ----------
     Prefers UpCart when it is on the page. UpCart loads as an app embed through
     content_for_header, so on a fast add it may not have defined its global yet
     — hence the short poll. Navigating to /cart is the last resort only, so the
     customer is never stranded if the app fails to load at all.              */
  function openCartDrawer() {
    var tries = 0;
    (function attempt() {
      if (typeof window.upcartOpenCart === 'function') {
        window.upcartOpenCart();
        return;
      }
      if (++tries < 15) {                       // ~1.5s
        setTimeout(attempt, 100);
        return;
      }
      console.warn('[heat-grump] No cart drawer available after 1.5s — falling back to /cart.');
      window.location.href = '/cart';
    })();
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      });
  }

  /* ---------- Money formatting ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';

    function defaultTo(number, size) {
      var s = '000000000' + number;
      return s.substr(s.length - size);
    }

    function thousands(number, precision, thousand, decimal) {
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      var cts = parts[1] ? decimal + defaultTo(parts[1], precision) : '';
      return dollars + cts;
    }

    switch ((fmt.match(placeholder) || [])[1]) {
      case 'amount':
        value = thousands(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = thousands(cents, 0, ',', '');
        break;
      case 'amount_with_comma_separator':
        value = thousands(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = thousands(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = thousands(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = thousands(cents, 0, ' ', '');
        break;
      default:
        value = thousands(cents, 2, ',', '.');
    }

    return fmt.replace(placeholder, value);
  }

  /* ---------- Product form: variants + bundles ---------- */
  function initProductForm(form) {
    var dataEl = form.querySelector('[data-variants]');
    var variants = [];
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    var bundlesWrap = form.querySelector('[data-bundles]');
    var moneyFormat = bundlesWrap ? bundlesWrap.getAttribute('data-money-format') : null;
    var addonId = bundlesWrap ? bundlesWrap.getAttribute('data-addon-id') : null;
    var quantityInput = form.querySelector('[data-quantity]');
    var idInput = form.querySelector('[name="id"]');
    var submit = form.querySelector('[type="submit"]');

    function currentVariant() {
      if (!variants.length) return null;
      var groups = form.querySelectorAll('[data-option-index]');
      if (!groups.length) {
        var byId = variants.filter(function (v) {
          return String(v.id) === String(idInput && idInput.value);
        })[0];
        return byId || variants[0];
      }
      var selected = Array.prototype.map.call(groups, function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      return variants.filter(function (variant) {
        return selected.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      })[0];
    }

    function selectedBundle() {
      if (!bundlesWrap) return null;
      return bundlesWrap.querySelector('.bundle.is-selected') || bundlesWrap.querySelector('[data-bundle]');
    }

    /* [CROW] renderBundlePrices removed.
       product-extras.js -> repriceForm() computes the same numbers, loads after
       this file, and wins. Its formula rounds payFor to the nearest 0.5, which
       is the correct one: for Buy 2 Get 1 Free this file gave 2.01 units where
       product-extras gives 2.00. Two functions deriving the same displayed price
       from the same data is a bug waiting to happen, so there is now one.     */

    function update() {
      var variant = currentVariant();

      if (!variant) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.getAttribute('data-unavailable') || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? submit.getAttribute('data-add') || 'Add To Cart'
          : submit.getAttribute('data-soldout') || 'Sold out';
      }

      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare-price]');
      var badgeEl = document.querySelector('[data-save-badge]');

      if (priceEl && variant.price_formatted) priceEl.innerHTML = variant.price_formatted;
      if (compareEl) {
        if (variant.compare_formatted) {
          compareEl.innerHTML = variant.compare_formatted;
          compareEl.classList.remove('hidden');
        } else {
          compareEl.classList.add('hidden');
        }
      }
      if (badgeEl) {
        if (variant.compare_at_price > variant.price) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          var label = badgeEl.querySelector('svg') ? badgeEl.lastChild : null;
          if (label && label.nodeType === 3) {
            label.textContent = ' SAVE ' + pct + '%';
          }
          badgeEl.classList.remove('hidden');
        } else {
          badgeEl.classList.add('hidden');
        }
      }

      /* [CROW] was: renderBundlePrices(variant);
         product-extras.js repriceAll() already runs on the same change event. */

      var bundle = selectedBundle();
      if (quantityInput) {
        quantityInput.value = bundle ? parseInt(bundle.getAttribute('data-quantity'), 10) || 1 : 1;
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-option-index] input')) {
        update();
        return;
      }

      if (event.target.matches('[data-bundles] input[type="radio"]')) {
        bundlesWrap.querySelectorAll('[data-bundle]').forEach(function (bundle) {
          bundle.classList.remove('is-selected');
        });
        var chosen = event.target.closest('[data-bundle]');
        if (chosen) chosen.classList.add('is-selected');
        update();
      }
    });

    /* Add to cart — supports bundle quantity + add-on product */
    /* [CROW] third argument `true` = capture phase, plus stopImmediatePropagation
       below. This makes our handler win the race against UpCart, so the bundle
       payload is built even when "Enhanced Ajax API compatibility" is OFF.
       Caveat: this only wins if UpCart hooks the form's submit event. If it hooks
       the button's click instead, that fires earlier and nothing here can help —
       in which case leave Enhanced Ajax ON, which is the recommended setting. */
    form.addEventListener('submit', function (event) {
      if (!bundlesWrap) return;

      event.preventDefault();
      event.stopImmediatePropagation();          // [CROW]

      var variant = currentVariant();
      if (!variant) return;

      var bundle = selectedBundle();
      var qty = bundle ? parseInt(bundle.getAttribute('data-quantity'), 10) || 1 : 1;
      var items = [{ id: variant.id, quantity: qty }];

      if (bundle && addonId) {
        var addonCheck = bundle.querySelector('[data-addon-check]');
        if (addonCheck && addonCheck.checked) {
          items.push({ id: parseInt(addonId, 10), quantity: 1 });
        }
      }

      var code = bundle ? (bundle.getAttribute('data-discount-code') || '').trim() : '';

      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || err.message || 'Could not add to cart');
            });
          }
          return response.json();
        })
        /* [CROW] was: window.location.href = '/cart'
           That single line is why every add landed on the cart page. */
        .then(function () {
          if (code) {
            // A discount code genuinely needs a navigation. Nothing to be done
            // about that — but discount_code is empty on all three bundle blocks,
            // so this branch does not currently run.
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
            return null;
          }
          return refreshCartCount().then(function () {
            openCartDrawer();
          });
        })
        .catch(function (err) {
          console.error('[heat-grump] add to cart failed:', err);
          if (err && err.message) alert(err.message);
        })
        /* [CROW] The original only restored the button inside .catch — it got
           away with it because the page always navigated. Without the redirect
           the button would stick on "Adding..." forever, so restore it always. */
        .then(function () {
          if (submit && !code) {
            submit.disabled = false;
            submit.textContent = submit.getAttribute('data-add') || 'Add To Cart';
          }
        });
    }, true);

    update();
  }

  document.querySelectorAll('[data-product-form]').forEach(initProductForm);

  /* ---------- Quick add from product cards ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-quick-add]');
    if (!form) return;

    event.preventDefault();
    var button = form.querySelector('button');
    var original = button ? button.innerHTML : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 }]
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        return refreshCartCount();
      })
      .then(function () {
        if (button) {
          button.textContent = 'Added ✓';
          setTimeout(function () {
            button.innerHTML = original;
            button.disabled = false;
          }, 1600);
        }
        openCartDrawer();                        // [CROW] quick add opens it too
      })
      .catch(function () {
        if (button) {
          button.innerHTML = original;
          button.disabled = false;
        }
      });
  });

  /* ---------- Smooth in-page scrolling ---------- */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    var offset = (document.querySelector('.header') || {}).offsetHeight || 0;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - offset - 12,
      behavior: 'smooth'
    });
  });
})();